import {Link} from "react-router-dom";
import {getHomepage, listProducts, type HomepageSection, type Product, type I18nKey} from "@corporatesclub/shared";
import {HOMEPAGE_HERO_SLIDES} from "@/components/shop/homepageCarouselSlides";
import {ProductCard} from "@/components/shop/ProductCard";
import {HomepageCarousel} from "@/components/shop/HomepageCarousel";
import {HomeDepartments} from "@/components/shop/HomeDepartments";
import {HomePromoTabs} from "@/components/shop/HomePromoTabs";
import {HomePerfumeSpotlight} from "@/components/shop/HomePerfumeSpotlight";
import {HomeBrandsMarquee} from "@/components/shop/HomeBrandsMarquee";
import {useI18n} from "@/components/shop/I18nProvider";
import {useEffect, useState} from "react";

const PROMO_SECTION: HomepageSection = {
  key: "promotii",
  titleKey: "LIMITED TIME DISCOUNTS",
  list: "promotii",
  moreUrl: "/promotions"
};

function ProductRow({list, titleKey, moreUrl}: {list: string; titleKey: I18nKey; moreUrl: string}) {
  const {t} = useI18n();
  const [items, setItems] = useState<Product[]>([]);
  useEffect(() => {
    listProducts({list, pageSize: 8}).then((r) => setItems(r.items)).catch(() => {});
  }, [list]);
  if(!items.length) return null;
  return (
    <section className="bx-homeProducts">
      <div className="cc-ds-sectionHeader bx-homeProducts__head">
        <h2 className="cc-ds-sectionHeader__title">{t(titleKey)}</h2>
        <Link to={moreUrl} className="cc-ds-sectionHeader__link">{t("More products")}</Link>
      </div>
      <div className="cc-productGrid">
        {items.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}

export function HomePage() {
  const [showPromo, setShowPromo] = useState(true);
  useEffect(() => {
    getHomepage().then((r) => {
      if(r.sections?.length) {
        setShowPromo(r.sections.some((s) => s.list === "promotii"));
      }
    }).catch(() => {});
  }, []);
  return (
    <div className="cc-homePage">
      <HomepageCarousel slides={HOMEPAGE_HERO_SLIDES} />
      <HomeDepartments />
      <HomePromoTabs />
      <HomePerfumeSpotlight />
      <HomeBrandsMarquee />
      {showPromo ? <ProductRow list={PROMO_SECTION.list} titleKey={PROMO_SECTION.titleKey as I18nKey} moreUrl={PROMO_SECTION.moreUrl} /> : null}
    </div>
  );
}
